/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_New_ListingInputs */

const en_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Listing`)
};

const es_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo anuncio`)
};

const fr_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle annonce`)
};

const de_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Inserat`)
};

const ja_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新規出品`)
};

const zh_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布新商品`)
};

const ar_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلان جديد`)
};

const id_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Baru`)
};

const it_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo Annuncio`)
};

const ru_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое объявление`)
};

const pt_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo Anúncio`)
};

const ko_seller_dashboard_new_listing = /** @type {(inputs: Seller_Dashboard_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 상품 등록`)
};

/**
* | output |
* | --- |
* | "New Listing" |
*
* @param {Seller_Dashboard_New_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_new_listing = /** @type {((inputs?: Seller_Dashboard_New_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_New_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_new_listing(inputs)
	if (locale === "es") return es_seller_dashboard_new_listing(inputs)
	if (locale === "fr") return fr_seller_dashboard_new_listing(inputs)
	if (locale === "de") return de_seller_dashboard_new_listing(inputs)
	if (locale === "ja") return ja_seller_dashboard_new_listing(inputs)
	if (locale === "zh") return zh_seller_dashboard_new_listing(inputs)
	if (locale === "ar") return ar_seller_dashboard_new_listing(inputs)
	if (locale === "id") return id_seller_dashboard_new_listing(inputs)
	if (locale === "it") return it_seller_dashboard_new_listing(inputs)
	if (locale === "ru") return ru_seller_dashboard_new_listing(inputs)
	if (locale === "pt") return pt_seller_dashboard_new_listing(inputs)
	return ko_seller_dashboard_new_listing(inputs)
});